import { MessageCircle, Phone, Clock, MapPin, Truck } from "lucide-react";
import { HOME } from "@/constants/testIds";
import { buildSms, telHref } from "@/lib/sms";
import { useLang } from "@/contexts/LangContext";
import { useSettings } from "@/contexts/SettingsContext";

export const Footer = () => {
  const { t } = useLang();
  const { shop } = useSettings();
  return (
    <footer
      data-testid={HOME.footer}
      className="relative border-t border-white/10 bg-[#050505] pb-32 sm:pb-24"
    >
      <div className="mx-auto max-w-7xl px-5 sm:px-8 py-14 grid grid-cols-1 md:grid-cols-3 gap-10">
        <div>
          <p className="font-display text-2xl font-extrabold tracking-tight">One Stop Shop</p>
          <p className="font-mono text-[10px] uppercase tracking-[0.3em] text-[#00ff41] mt-1">
            {shop.city}
          </p>
          <p className="mt-4 text-neutral-400 text-sm leading-relaxed max-w-sm">
            {t("footer_blurb")}
          </p>
        </div>

        <div className="grid grid-cols-2 gap-4">
          <Info icon={<Clock size={14} />} label={t("hours")} value={t("open_247")} />
          <Info icon={<MapPin size={14} />} label={t("zone")} value="Ottawa · Gatineau" />
          <Info icon={<Truck size={14} />} label={t("free_over")} value={`$${shop.freeDeliveryThreshold}`} />
          <Info icon={<Phone size={14} />} label={t("phone_label")} value={shop.phoneDisplay} />
        </div>

        <div className="flex flex-col items-start md:items-end gap-3">
          <a
            href={buildSms({ categoryId: "footer" })}
            className="inline-flex items-center gap-2 rounded-full bg-[#00ff41] px-5 py-3 font-display font-bold text-black hover:bg-[#00e63a] transition"
          >
            <MessageCircle size={16} />
            {t("text_to_order")}
          </a>
          <a
            href={telHref()}
            className="inline-flex items-center gap-2 rounded-full border border-white/15 bg-white/5 px-5 py-3 font-display font-semibold hover:bg-white/10 transition"
          >
            <Phone size={16} />
            {t("call")} {shop.phoneDisplay}
          </a>
          <p className="text-xs text-neutral-500 mt-2">{t("must_19")}</p>
        </div>
      </div>

      <div className="mx-auto max-w-7xl px-5 sm:px-8 pb-8 border-t border-white/10 pt-6 flex flex-col sm:flex-row justify-between gap-3 text-xs text-neutral-500">
        <p>
          © {new Date().getFullYear()} OSS Ottawa · One Stop Shop. {t("rights_reserved")}
        </p>
        <p className="font-mono uppercase tracking-[0.25em]">{t("tagline_short")}</p>
      </div>
    </footer>
  );
};

const Info = ({ icon, label, value }) => (
  <div className="rounded-2xl border border-white/10 bg-white/[0.03] p-3">
    <div className="flex items-center gap-1.5 text-[#00ff41]">
      {icon}
      <span className="font-mono text-[9px] uppercase tracking-[0.25em] text-neutral-400">{label}</span>
    </div>
    <p className="mt-1 font-display text-sm font-bold">{value}</p>
  </div>
);

export default Footer;
